import React from 'react'
import Img1 from '../../images/Mechanical/mechnical2.png'
import Img12 from '../../images/Mechanical/IMG_38362.jpg'
import Solid from '../../images/Mechanical/process.png'
import Tools from '../../images/Mechanical/tools.png'
import Mechanic from '../../images/Mechanical/mechanic.png'
import Ruler from '../../images/Mechanical/ruler.png'
import Pen from '../../images/Mechanical/3d-printer.png'
import mech from '../../images/Mechanical/mech.png'
import AnimatedElement from '../../components/AnimatedElement'
import TransitionPage from '../../TransitionPage'
import RevealText from '../../components/TextReveal2'
import ImageSlider from '../../components/ImageSlider'

function Mechanical() {
    const images = [
        Img1,
        Img12
    ]
    return (
        <TransitionPage>

            <div className='h-auto text-black bg-gray-100    '>

<div className='relative w-full h-[100vh] min-h-[500px] flex items-center justify-center overflow-hidden'>
    
    <div className='absolute z-40 pointer-events-none'>
        <RevealText 
            text='Mechanical Department' 
            css='uppercase text-[3rem] after:bg-black bg-black p-3 bg-opacity-60 max-sm:text-[1.2rem] font-bold text-white' 
        />
    </div>

    {/* 2. Force the slider container to be 100% height and width */}
    <div className='w-full h-full [&_img]:h-full [&_img]:w-full [&_img]:object-cover'>
        <ImageSlider images={images} autoPlay={true} autoPlayInterval={4000} />
    </div>
</div>
                <AnimatedElement direction='from-down'>
                    <div className='flex max-sm:flex-col items-center  justify-center gap-5 py-6 px-10 max-sm:px-3'>

                        <div className=' flex-[3]  h-full px-10 max-sm:px-3'>
                            <p className='text-justify text-[1em] '>
                                <RevealText text='The Mechanical Department' css='text-[2rem] after:bg-black max-sm:text-[1.2rem] font-bold uppercase' />

                                <span>
                                    This department customizes mechanical systems to meet the unique requirements of these instruments, guaranteeing their reliability in critical scenarios.
                                    Structural Analysis and Design techniques are rigorously applied to safeguard the integrity and longevity of vital components, while Materials Science and Engineering advancements optimize their weight, resilience, and performance. We employ state-of-the-art Prototyping and
                                    Testing facilities to validate designs, assess performance metrics, and mitigate risks before deployment, ensuring the operational readiness
                                    and reliability of our products.
                                </span>

                            </p>
                        </div>
                        <div className='flex-1'>
                            <img alt='mech' src={mech} />
                        </div>

                    </div>
                </AnimatedElement>

                {/* <h1 className='text-[3rem] text-[#425472] uppercase font-bold'>Facilities</h1> */}
                <RevealText text='Facilities' css='uppercase text-[3rem] after:bg-[#425472] max-sm:text-[2rem] font-bold text-[#425472]' />
                {/* <AnimatedElement direction='from-left'> */}

                <div className='py-5  max-sm:px-3 max-sm:flex-col flex items-center '>
                    <AnimatedElement direction='from-down'>

                        <Facility width={70} fac="Advanced Designing and Analysis Capabilities with Solid Works Professional 2025." img={Solid} />
                    </AnimatedElement>
                    <AnimatedElement direction='from-down' delayAn='0.2'>

                        <Facility width={70} img={Pen} fac="3D printing technology with more than 20 high end 3D printers " />
                    </AnimatedElement>
                    <AnimatedElement direction='from-down' delayAn='0.23'>

                        <Facility width={70} img={Tools} fac="Equipped with high precision machines and hand tools" />
                    </AnimatedElement>
                    <AnimatedElement direction='from-down' delayAn='0.26'>

                        <Facility width={70} img={Mechanic} fac="Experienced personnel for operating and maintaining machines and tools" />
                    </AnimatedElement>
                    <AnimatedElement direction='from-down' delayAn='0.29'>

                        <Facility width={70} img={Ruler} fac="High precision measuring instruments, such as calipers and micrometers." />
                    </AnimatedElement>
                </div>
                {/* </AnimatedElement> */}
                {/* <div className='flex items-center justify-center mt-14 gap-4'>
                <img className='' width='300' src={Img2} alt='img2' />
                <img className='' width='300' src={Img3} alt='img3' />
                </div> */}

            </div>
        </TransitionPage>
    )
}

function Facility({ fac, img, width }) {
    return (

        <div className='font-medium scale-90 w-[300px] text-[1em] h-full flex-[1] text-justify flex flex-col-reverse gap-3 items-center justify-evenly rounded-xl bg-gray-200 text-[#2f3746] p-3 py-[50px] max-sm:py-4 shadow-md hover:scale-95 transition'>
            <p>{fac}</p>
            <img alt='mech' src={img} width={width} />
        </div>
    )
}

export default Mechanical